import RefreshIcon from "@mui/icons-material/Refresh";
import { Grid, IconButton } from "@mui/material";
import { UserFilter } from "services/organizationPortalClient";
import { AddUser } from "./AddUser";
import ExportUsers from "./ExportUsers";
import { ImportUsers } from "./ImportUsers";

type ActionButtonsProps = {
  sortField: string;
  sortDescending: boolean;
  userFilter: UserFilter;
  refetch: () => void;
};

export default function UserActionButtons({
  sortField,
  sortDescending,
  userFilter,
  refetch,
}: Readonly<ActionButtonsProps>) {
  return (
    <Grid container columnSpacing={2} wrap="nowrap">
      <Grid item>
        <ExportUsers
          sortField={sortField}
          sortDescending={sortDescending}
          userFilter={userFilter}
        />
      </Grid>
      <Grid item>
        <ImportUsers />
      </Grid>
      <Grid item>
        <AddUser />
      </Grid>
      <Grid item>
        <IconButton onClick={refetch}>
          <RefreshIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
}
